import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { BUSINESS_NAME } from "@/core/constants/business";

interface AuthorCardProps {
  authorName: string;
  authorRole: string;
  authorImage?: string;
}

const AuthorCard: React.FC<AuthorCardProps> = ({
  authorName,
  authorRole,
  authorImage = "/images/lonny-the-street-lawyer/lonny-the-street-lawyer-profile-picture.jpg",
}) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    // Function to add loaded class when image loads
    const handleLoad = () => {
      img.classList.add("loaded");
    };

    // Check if image is already loaded (from cache)
    if (img.complete) {
      handleLoad();
    } else {
      img.addEventListener("load", handleLoad);
    }

    return () => {
      if (img) {
        img.removeEventListener("load", handleLoad);
      }
    };
  }, [authorImage]);

  return (
    <div className="bg-law-black-600/70 backdrop-blur-sm rounded-xl shadow-md p-4 mb-5 sidebar-item border border-justice-gold-500/20">
      <div className="flex items-center">
        <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-justice-gold-500/50">
          <img
            ref={imgRef}
            src={authorImage}
            alt={authorName}
            className="w-full h-full object-cover lazy-image" // Changed class name
            loading="lazy"
          />
        </div>
        <div className="ml-4">
          <h3 className="font-bold text-base text-justice-gold-400">
            {authorName}
          </h3>
          <p className="text-gray-400 text-sm">
            {authorRole} of {BUSINESS_NAME}
          </p>
          <Link
            to="/about"
            className="text-cannabis-green-400 hover:text-cannabis-green-300 text-xs font-medium flex items-center mt-1 group"
          >
            <span>About </span>
            <svg
              className="w-3 h-3 ml-1 transition-transform group-hover:translate-x-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;
